import { TRAINING_STATUS, EDR_AGENT_STATUS } from '@/lib/constants/employees'
import { SIGNED_STATUS } from '@/lib/constants/policies'
import { EMPLOYEE_IDENTITY_STATES } from '@/lib/constants/identities'
export const EMPLOYEE_TABLE = {
  TITLE: 'Employee List',
  PAGE_TITLE: 'Employees Dashboard',
  ADD_EMPLOYEE: 'Add Employee',
  EXPORT_SIGNATURES: 'Export signatures',
  EXPORT_SIGNATURES_EMPTY: 'There are no policy signatures to export yet.',
  EXPORT_EMPLOYEES: 'Export employees',
  EXPORT_EMPLOYEES_EMPTY: 'There are no employees to export.',
  SEARCH_PLACEHOLDER: 'Search employees...',
  TABLE_HEADER: {
    NAME: 'Name',
    EMAIL: 'Email',
    POLICIES_SIGNED: 'Policies',
    TRAINING_COMPLETED: 'Training',
    ROLE: 'Role',
    DEPARTMENT: 'Department',
    IDENTITIES: 'Identities',
    EDR_AGENT: 'EDR Agent',
    SAAS_ACCESS: 'SaaS',
    SSO: 'SSO',
  },
  FILTER_BY_ROLE: 'Filter by role',
  FILTER_BY_POLICY_STATUS: 'Filter by policy status',
  FILTER_BY_TRAINING_STATUS: 'Filter by training status',
  FILTER_BY_IDENTITIES: 'Filter by identities',
  FILTER_BY_EDR_AGENT: 'Filter by EDR agent status',
  FILTER_BY_SAAS: 'Filter by SaaS',
  IDENTITY_STATUS: {
    all: 'All',
    [EMPLOYEE_IDENTITY_STATES.ACTIVE]: 'Active',
    [EMPLOYEE_IDENTITY_STATES.REMOVED]: 'Removed',
    [EMPLOYEE_IDENTITY_STATES.NONE]: 'No identity',
    service: 'Service',
  },
}
export const EMPLOYEE_CREATION_DIALOG = {
  TITLE: 'New Employee',
  NAME: 'Name',
  EMAIL: 'Email',
  BULK_UPLOAD: 'Bulk Upload',
  CREATE: 'Create',
  CANCEL: 'Cancel',
  BULK_UPLOAD_TEMPLATE: 'Bulk Upload Template',
  SUCCESS_MESSAGE: (name: string) => `Employee "${name}" created successfully`,
  BULK_UPLOAD_SUCCESS_MESSAGE: 'Successfully created employees',
  ERROR_MESSAGE: 'Please fill in all fields',
  TRAINING_STATUS: 'Training Status',
  ROLE: 'Role',
}
export const EMPLOYEE_BULK_UPLOAD_DIALOG = {
  TITLE: 'Bulk Upload Employees',
  DESCRIPTION: 'Upload a CSV or Excel file to create multiple employees at once.',
  UPLOAD_FILE: 'Upload File',
  UPLOADING: 'Uploading...',
  TEMPLATE: 'Template',
  CREATING_USERS: 'Creating employees in bulk...',
  SUCCESS: 'Employees created successfully',
  CANCEL: 'Cancel',
}
export const SIGNED_POLICIES = {
  [SIGNED_STATUS.SIGNED]: 'Signed',
  [SIGNED_STATUS.NOT_SIGNED]: 'Not Signed',
  [SIGNED_STATUS.PARTIALLY_SIGNED]: 'Partially Signed',
}
export const TRAINING_STATUS_TEXTS = {
  [TRAINING_STATUS.COMPLETED]: 'Completed',
  [TRAINING_STATUS.NOT_COMPLETED]: 'Pending',
  [TRAINING_STATUS.PARTIALLY_COMPLETED]: 'In Progress',
  [TRAINING_STATUS.UNKNOWN]: 'Unknown',
}
export const EDR_AGENT_STATUS_TEXTS = {
  [EDR_AGENT_STATUS.INSTALLED]: 'Installed',
  [EDR_AGENT_STATUS.NOT_INSTALLED]: 'Not Installed',
}
export const EMPLOYEE_BULK_ACTIONS = {
  SELECTED_SINGULAR: 'user selected',
  SELECTED_PLURAL: 'users selected',
  CLEAR: 'Clear',
  DELETE_SELECTED: 'Delete selected',
  CONFIRM_DELETE_TITLE: 'Delete users',
  CONFIRM_DELETE_DESCRIPTION: (count: number) =>
    `Are you sure you want to delete ${count} user(s)? This action cannot be undone.`,
}
export const EMPLOYEE_DRAWER = {
  TAB_GENERAL: 'General',
  TAB_SAAS: (count: number) => `SaaS (${count})`,
  TAB_LIFECYCLE: 'Onboarding / Offboarding',
  PROFILE: 'Profile',
  COMPLIANCE: 'Compliance',
  EMPLOYEE_DETAILS: 'Employee Details',
  INFORMATION: 'Information',
  ATTRIBUTES: 'Attributes',
  NAME: 'Name',
  EMAIL: 'Email',
  ROLE: 'Role',
  DEPARTMENTS: 'Departments',
  SSO: 'SSO',
  IDENTITY_SOURCES: 'Identity Sources',
  IDENTITIES: 'Identities',
  TRAINING_STATUS: 'Training Status',
  POLICIES_SIGNED: 'Policies Signed',
  SIGN_ALL: 'Sign all',
  CLEAR_ALL: 'Clear all',
  SIGNATURE_ACTIONS: 'Signature actions',
  CLEAR_ALL_SIGNATURES: 'Clear all signatures',
  CLEAR_ALL_SIGNATURES_TITLE: 'Clear all signatures?',
  CLEAR_ALL_SIGNATURES_DESCRIPTION: (name: string) =>
    `This removes every recorded policy signature for ${name}. This cannot be undone.`,
  SIGNATURES_CLEARED: (count: number) => `${count} signature${count === 1 ? '' : 's'} removed.`,
  NO_POLICIES_TO_SIGN: 'This organization has no policies available to sign yet.',
  POLICY_SIGNATURES: 'Policy signatures',
  POLICY_SIGNATURES_EMPTY: 'No policies listed',
  POLICY_SIGNATURES_ERROR: 'Error loading policies',
  POLICY_SIGNATURES_LATEST: (versionNumber: number) => `latest v${versionNumber}`,
  EDR_AGENT: 'EDR Agent',
  IDENTITY_ACTIVE: 'Identity is active',
  IDENTITY_INACTIVE: 'Identity is inactive',
  DELETE_USER: 'Delete user',
  CONFIRM_DELETE_USER: 'Are you sure you want to delete this user? This action cannot be undone.',
  USER_DELETED: 'User deleted successfully',
  ROLE_UPDATED: 'Role updated successfully',
  SAAS_ACCESS: 'SaaS Management',
  HIDE_INTERNAL_APPS: 'Hide internal apps',
  INTERNAL_APP: 'Internal',
  ACCESS_GRANTED: 'Access granted',
  SOURCE: 'Source',
  NOT_AVAILABLE: 'N/A',
  NOT_ASSIGNED_TO_DEPARTMENTS: "Not assigned to user's departments",
  SOURCE_TOOLTIP: (source: string) => `Source: ${source}`,
  ACCESS_GRANTED_ON: (date: string) => `Access granted on ${date}`,
  TWO_FA_SHORT: '2FA',
  TWO_FA_ENABLED_ON: (source: string) => `2FA enabled via ${source} for this SaaS`,
  TWO_FA_DISABLED_ON: (source: string) => `2FA disabled on ${source} for this SaaS`,
  TWO_FA_UNKNOWN_FOR: (source: string) => `2FA status unknown on ${source} for this SaaS`,
  TWO_FA_UNKNOWN: '2FA status unknown',
}

export const DEPARTMENT_SELECTOR = {
  SELECT_DEPARTMENTS: 'Select departments',
  ADD_MORE: 'Add department',
  SEARCH: 'Search departments...',
  LOADING: 'Loading...',
  NO_DEPARTMENTS_FOUND: 'No departments found.',
}
export const ONBOARDING_SECTION = {
  TITLE: 'Onboarding',
  START_ONBOARDING: 'Start Onboarding',
  STARTING: 'Starting...',
  EMPTY_MESSAGE: 'Employee not onboarded yet.',
}
export const OFFBOARDING_SECTION = {
  TITLE: 'Offboarding',
  START_OFFBOARDING: 'Start Offboarding',
  STARTING: 'Starting...',
  EMPTY_MESSAGE: 'Employee not offboarded yet.',
}
export const CHECKLIST_EDIT = {
  EDIT: 'Edit',
  DONE: 'Done',
  ADD_TASK: 'Add task',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  REMOVE: 'Remove',
  RESET_TO_DEFAULTS: 'Reset to defaults',
  RESET_CONFIRM_TITLE: 'Reset checklist?',
  RESET_CONFIRM_BODY:
    'This will replace the entire checklist with the default items. Custom items will be lost. In-flight employees will get a fresh copy. This cannot be undone.',
  EDIT_BANNER_TITLE: 'You are editing the org template',
  EDIT_BANNER_BODY: 'Changes apply to all current and future employees in this organization.',
  RENAME_PLACEHOLDER: 'Task name',
  REMOVE_CONFIRM_TITLE: 'Remove this item?',
  REMOVE_CONFIRM_BODY:
    'It will be removed from this and every employee\u2019s checklist, including completed instances. This cannot be undone.',
  CONTROL_NONE: 'No control',
  CONTROL_SEARCH_PLACEHOLDER: 'Search controls...',
  CONTROL_LABEL: 'Linked control',
  EDIT_TOOLTIP: 'Edit checklist template',
  DRAG_HANDLE_LABEL: 'Drag to reorder',
  REMOVE_BUTTON_LABEL: 'Remove item',
  MENU_LABEL: 'Checklist actions',
}
